module.exports = "https://static.wmbcdn.com/uniweb/images/adec6351719739217d0202b2c3ce5aad.svg";